import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Logo from '../../assets/img/Nlogo.svg';
import { C, PILLARS, PILLAR_COLORS } from '../../design/tokens';

const ICONS = {
  grid: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round"><rect x="2" y="2" width="5" height="5" rx="1"/><rect x="9" y="2" width="5" height="5" rx="1"/><rect x="2" y="9" width="5" height="5" rx="1"/><rect x="9" y="9" width="5" height="5" rx="1"/></svg>,
  shield: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1.5L2.5 4v4c0 3.5 2.5 5.5 5.5 6.5 3-1 5.5-3 5.5-6.5V4L8 1.5z"/></svg>,
  search: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round"><circle cx="7" cy="7" r="4.5"/><line x1="10.5" y1="10.5" x2="14" y2="14"/></svg>,
  'file-text': (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9.5 1.5H4a1 1 0 00-1 1v11a1 1 0 001 1h8a1 1 0 001-1V4.5L9.5 1.5z"/><polyline points="9.5,1.5 9.5,4.5 13,4.5"/><line x1="5.5" y1="7.5" x2="10.5" y2="7.5"/><line x1="5.5" y1="9.5" x2="10.5" y2="9.5"/><line x1="5.5" y1="11.5" x2="8" y2="11.5"/></svg>,
  clipboard: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.5 2.5h1a1 1 0 011 1v10a1 1 0 01-1 1h-7a1 1 0 01-1-1v-10a1 1 0 011-1h1"/><rect x="5.5" y="1" width="5" height="2.5" rx="1"/></svg>,
  heart: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 14s-5.5-3.5-5.5-7.5a3 3 0 015.5-1.7A3 3 0 0113.5 6.5C13.5 10.5 8 14 8 14z"/></svg>,
  'trending-up': (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="14,3 14,7 10,7"/><polyline points="2,13 6,9 9,11 14,3"/></svg>,
  layers: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="8,1.5 14.5,5 8,8.5 1.5,5"/><polyline points="1.5,8 8,11.5 14.5,8"/><polyline points="1.5,11 8,14.5 14.5,11"/></svg>,
  'dollar-sign': (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="1" x2="8" y2="15"/><path d="M11.5 4.5C11.5 3.5 10 2.5 8 2.5S4.5 3.5 4.5 4.5 5.5 6.5 8 7s3.5 1.5 3.5 2.5S10 12.5 8 12.5s-3.5-1-3.5-2"/></svg>,
  'credit-card': (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1.5" y="3" width="13" height="10" rx="1.5"/><line x1="1.5" y1="6.5" x2="14.5" y2="6.5"/></svg>,
  sunset: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12.5a6 6 0 0112 0"/><line x1="8" y1="2" x2="8" y2="5"/><line x1="3.5" y1="7" x2="4.5" y2="8"/><line x1="1" y1="12.5" x2="15" y2="12.5"/><line x1="11.5" y1="8" x2="12.5" y2="7"/></svg>,
  home: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2.5 6.5L8 2l5.5 4.5V13a1 1 0 01-1 1h-9a1 1 0 01-1-1V6.5z"/><polyline points="6,14 6,9 10,9 10,14"/></svg>,
  calculator: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2.5" y="1.5" width="11" height="13" rx="1.5"/><rect x="4.5" y="3.5" width="7" height="3" rx="0.5"/><line x1="5" y1="9.5" x2="5.5" y2="9.5"/><line x1="8" y1="9.5" x2="8.5" y2="9.5"/><line x1="11" y1="9.5" x2="11.5" y2="9.5"/><line x1="5" y1="12" x2="5.5" y2="12"/><line x1="8" y1="12" x2="8.5" y2="12"/><line x1="11" y1="12" x2="11.5" y2="12"/></svg>,
  'check-square': (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="5.5,8 7.5,10 11,5.5"/><rect x="2" y="2" width="12" height="12" rx="2"/></svg>,
  percent: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12.5" y1="3.5" x2="3.5" y2="12.5"/><circle cx="4.5" cy="4.5" r="1.5"/><circle cx="11.5" cy="11.5" r="1.5"/></svg>,
  clock: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="8" r="6.5"/><polyline points="8,4 8,8 11,9.5"/></svg>,
  activity: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="1,8 4,8 6,3 8,13 10,6 12,8 15,8"/></svg>,
  user: (color) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="5" r="3"/><path d="M2.5 14.5a5.5 5.5 0 0111 0"/></svg>,
};

const PILLAR_NAV = [
  {
    key: 'insurance',
    label: 'Insurance',
    dotColor: PILLAR_COLORS.insurance.border,
    items: [
      { name: 'Get a Quote', path: '/quote', icon: 'shield' },
      { name: 'Insurance Explorer', path: '/insurance-explorer', icon: 'search' },
      { name: 'My Quotes', path: '/panel', icon: 'file-text', badgeKey: 'quoteCount' },
      { name: 'My Policies', path: '/my-policies', icon: 'clipboard' },
    ],
  },
  {
    key: 'retirement',
    label: 'Retirement Solutions',
    dotColor: PILLAR_COLORS.retirement.border,
    items: [
      { name: 'Investor Profile', path: '/investor-profile', icon: 'trending-up' },
      { name: 'Retirement Planner', path: '/retirement-planner', icon: 'sunset' },
    ],
  },
  {
    key: 'financial',
    label: 'Financial Management',
    dotColor: PILLAR_COLORS.financial.border,
    items: [
      { name: 'Health Checkup', path: '/health-score', icon: 'heart' },
      { name: 'Balance Sheet', path: '/balance-sheet', icon: 'layers' },
      { name: 'Cash Flow', path: '/cash-flow', icon: 'dollar-sign' },
      { name: 'Debt Planner', path: '/debt-planner', icon: 'credit-card' },
    ],
  },
  {
    key: 'estate',
    label: 'Estate Planning',
    dotColor: PILLAR_COLORS.estate.border,
    items: [
      { name: 'Estate Readiness', path: '/estate-planner', icon: 'home' },
      { name: 'Estate Cost Calculator', path: '/estate-cost', icon: 'calculator' },
      { name: 'Will Checklist', path: '/will-checklist', icon: 'check-square' },
    ],
  },
  {
    key: 'learn',
    label: 'Learn',
    dotColor: null,
    items: [
      { name: 'Calculators', path: '/panel/calculators', icon: 'percent' },
      { name: 'Money Minute', path: '/money-minute', icon: 'clock' },
      { name: 'Financial Pulse', path: '/markets', icon: 'activity' },
    ],
  },
];

const SECTION_DEFAULTS = { insurance: true, retirement: false, financial: false, estate: false, learn: false };

function Sidebar({ quoteCount, notificationCount, onSignOut, currentPath }) {
  const location = useLocation();
  const activePath = currentPath || location.pathname + location.search + location.hash;
  const [credits, setCredits] = useState(0);

  const [openSections, setOpenSections] = useState(() => {
    try {
      const stored = localStorage.getItem('gc_sidebar_sections');
      if (stored) return { ...SECTION_DEFAULTS, ...JSON.parse(stored) };
    } catch (e) { /* ignore */ }
    return { ...SECTION_DEFAULTS };
  });

  useEffect(() => {
    axios.post('details').then(res => {
      const u = res.data?.success || res.data?.data || res.data;
      if (u?.token_balance != null) setCredits(u.token_balance);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    for (const section of PILLAR_NAV) {
      const match = section.items.some((item) => {
        const hashPath = item.path.replace('/', '');
        return activePath.includes(hashPath);
      });
      if (match && !openSections[section.key]) {
        setOpenSections((prev) => {
          const next = { ...prev, [section.key]: true };
          try { localStorage.setItem('gc_sidebar_sections', JSON.stringify(next)); } catch (e) { /* ignore */ }
          return next;
        });
        break;
      }
    }
  }, [activePath]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleSection = (key) => {
    setOpenSections((prev) => {
      const next = { ...prev, [key]: !prev[key] };
      try { localStorage.setItem('gc_sidebar_sections', JSON.stringify(next)); } catch (e) { /* ignore */ }
      return next;
    });
  };

  const isActive = (itemPath) => {
    const hashPath = itemPath.replace('/', '');
    return activePath.includes(hashPath);
  };

  const badgeValues = { quoteCount, notificationCount };

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, width: 240, height: '100vh',
        backgroundColor: C.navy, overflowY: 'auto', display: 'flex',
        flexDirection: 'column', zIndex: 1000, fontFamily: "'Outfit', sans-serif",
      }}
    >
      {/* Logo */}
      <div style={{ padding: '20px 20px 12px', textAlign: 'center' }}>
        <img src={Logo} alt="GetCovered"
          style={{ width: 140, height: 'auto', display: 'block', margin: '0 auto', filter: 'brightness(0) invert(1)' }}
          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
        />
        <span style={{ display: 'none', color: '#EAC54D', fontSize: 18, fontWeight: 700 }}>GetCovered</span>
      </div>

      {/* Credits Display */}
      <div style={{ margin: '0 16px 8px', padding: 12, backgroundColor: 'rgba(255,255,255,0.07)', borderRadius: 8 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: C.blue, fontSize: 13, fontWeight: 600 }}>Credits: {credits}</span>
        </div>
      </div>

      {/* Navigation */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {/* Dashboard — standalone item */}
        <NavItem name="Dashboard" path="/dashboard" icon="grid" active={isActive('/dashboard')} badgeCount={0} />

        {/* Pillar sections */}
        {PILLAR_NAV.map((section) => {
          const isOpen = !!openSections[section.key];
          return (
            <div key={section.key}>
              <SectionHeader
                label={section.label}
                isOpen={isOpen}
                onClick={() => toggleSection(section.key)}
                dotColor={section.dotColor}
              />
              <div style={{ overflow: 'hidden', maxHeight: isOpen ? 500 : 0, transition: 'max-height 200ms ease' }}>
                {section.items.map((item) => {
                  const active = isActive(item.path);
                  const badgeCount = item.badgeKey ? badgeValues[item.badgeKey] : 0;
                  return (
                    <NavItem key={item.path} name={item.name} path={item.path} icon={item.icon} active={active} badgeCount={badgeCount} />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      {/* Book a CFP Card */}
      <Link to="/book" style={{
        display: 'block', margin: 16, padding: 12, backgroundColor: '#EAC54D',
        borderRadius: 8, textDecoration: 'none',
      }}>
        <span style={{ color: C.navy, fontWeight: 700, fontSize: 13, display: 'block' }}>
          Book a Free Consultation
        </span>
        <div style={{ color: C.navy, fontSize: 11, marginTop: 4, opacity: 0.8 }}>
          Schedule a session with a Certified Financial Planner
        </div>
      </Link>

      {/* Sign Out */}
      <button onClick={onSignOut}
        style={{
          padding: '12px 20px', background: 'transparent', color: '#fff', fontSize: 13,
          cursor: 'pointer', border: 'none', borderTop: '1px solid rgba(255,255,255,0.1)',
          textAlign: 'left', width: '100%', fontFamily: "'Outfit', sans-serif",
        }}>
        Sign Out
      </button>
    </div>
  );
}

function SectionHeader({ label, isOpen, onClick, dotColor }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        fontSize: 10, textTransform: 'uppercase', letterSpacing: 1.5,
        color: hovered ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.4)',
        padding: '12px 16px', cursor: 'pointer', display: 'flex',
        justifyContent: 'space-between', alignItems: 'center',
        userSelect: 'none', fontWeight: 600,
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {dotColor && <span style={{ width: 6, height: 6, borderRadius: '50%', background: dotColor, flexShrink: 0 }} />}
        {label}
      </span>
      <span style={{ fontSize: 8, transition: 'transform 200ms' }}>
        {isOpen ? '\u25BC' : '\u25B6'}
      </span>
    </div>
  );
}

function NavItem({ name, path, icon, active, badgeCount }) {
  const [hovered, setHovered] = useState(false);
  const itemColor = active ? '#fff' : (hovered ? 'rgba(255,255,255,0.9)' : '#fff');
  const iconColor = active ? C.blue : (hovered ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.7)');

  return (
    <Link
      to={path}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '8px 16px 8px 20px', color: itemColor,
        fontSize: 13, textDecoration: 'none',
        borderLeft: active ? `3px solid ${C.blue}` : '3px solid transparent',
        backgroundColor: active ? 'rgba(255,255,255,0.1)' : (hovered ? 'rgba(255,255,255,0.05)' : 'transparent'),
        transition: 'background 0.15s ease', cursor: 'pointer',
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
        {ICONS[icon] ? ICONS[icon](iconColor) : null}
      </span>
      <span style={{ flex: 1 }}>{name}</span>
      {badgeCount > 0 && (
        <span style={{
          backgroundColor: C.blue, color: '#fff', fontSize: 10, fontWeight: 700,
          minWidth: 18, height: 18, borderRadius: 9, display: 'flex', alignItems: 'center',
          justifyContent: 'center', padding: '0 5px',
        }}>
          {badgeCount}
        </span>
      )}
    </Link>
  );
}

export default Sidebar;
